// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.optionBtn{
    color: var(--light) !important; 
    text-decoration: none !important; 
    border: 1px solid var(--palleteGray); 
    /* border-style:  */
    border-top-left-radius: 25% 50% ;
    border-bottom-left-radius: 25% 50% ;
    border-top-right-radius: 25% 50% ;
    border-bottom-right-radius: 25% 50%;
    background: var(--semiDark);
    text-align: center; 
    transition-property: transform;
    transition-duration: 1.5s;
    box-shadow: inset -3px 3px 6px var(--light),
        inset -2px 0px 5px var(--primary),
        -5px 8px 8px var(--dark),
        5px 8px 8px var(--palleteGray);
}

#homeBlurb{
    color: var(--light);
}

#homeBlurb.tablet{
    background-color: var(--semiDark);
    box-shadow: inset -4px 10px 5px var(--light),
    inset 5px -7px 5px var(--primary),
    -5px 8px 8px var(--dark),
    5px 8px 8px var(--palleteGray);
    border-top-left-radius: 25% 50% ;
    border-bottom-left-radius: 25% 50% ;
    border-top-right-radius: 25% 50% ;
    border-bottom-right-radius: 25% 50%;
}
#homeBlurb.mobile{
    background-color: var(--semiDark);
    box-shadow:
        inset 0px 6px 5px var(--light),
        inset 0px -5px 5px var(--primary),
        -5px 8px 8px var(--dark),
        5px 8px 8px var(--palleteGray);
    border-top-left-radius: 50% 20% ;
    border-bottom-left-radius: 50% 20% ;
    border-top-right-radius: 50% 20% ;
    border-bottom-right-radius: 50% 20%;
}
.slider0{
    transition-property: height, width; 
    transition-duration: 1s; 
    transition-delay: 500ms;
}

.card-header{
    font-family: 'Rockwell', 'Rokkitt', 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;
}

.header-bg{
    background-position-y: 43% !important;
}

.iconLink{
    color: var(--light)
}
.iconLink:hover{
    color: var(--spark); 
}`, "",{"version":3,"sources":["webpack://./src/Pages/Home/home.lazy.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,gCAAgC;IAChC,oCAAoC;IACpC,mBAAmB;IACnB,gCAAgC;IAChC,mCAAmC;IACnC,iCAAiC;IACjC,mCAAmC;IACnC,2BAA2B;IAC3B,kBAAkB;IAClB,8BAA8B;IAC9B,yBAAyB;IACzB;;;sCAGkC;AACtC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iCAAiC;IACjC;;;kCAG8B;IAC9B,gCAAgC;IAChC,mCAAmC;IACnC,iCAAiC;IACjC,mCAAmC;AACvC;AACA;IACI,iCAAiC;IACjC;;;;sCAIkC;IAClC,gCAAgC;IAChC,mCAAmC;IACnC,iCAAiC;IACjC,mCAAmC;AACvC;AACA;IACI,kCAAkC;IAClC,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,4HAA4H;AAChI;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI;AACJ;AACA;IACI,mBAAmB;AACvB","sourcesContent":[".optionBtn{\n    color: var(--light) !important; \n    text-decoration: none !important; \n    border: 1px solid var(--palleteGray); \n    /* border-style:  */\n    border-top-left-radius: 25% 50% ;\n    border-bottom-left-radius: 25% 50% ;\n    border-top-right-radius: 25% 50% ;\n    border-bottom-right-radius: 25% 50%;\n    background: var(--semiDark);\n    text-align: center; \n    transition-property: transform;\n    transition-duration: 1.5s;\n    box-shadow: inset -3px 3px 6px var(--light),\n        inset -2px 0px 5px var(--primary),\n        -5px 8px 8px var(--dark),\n        5px 8px 8px var(--palleteGray);\n}\n\n#homeBlurb{\n    color: var(--light);\n}\n\n#homeBlurb.tablet{\n    background-color: var(--semiDark);\n    box-shadow: inset -4px 10px 5px var(--light),\n    inset 5px -7px 5px var(--primary),\n    -5px 8px 8px var(--dark),\n    5px 8px 8px var(--palleteGray);\n    border-top-left-radius: 25% 50% ;\n    border-bottom-left-radius: 25% 50% ;\n    border-top-right-radius: 25% 50% ;\n    border-bottom-right-radius: 25% 50%;\n}\n#homeBlurb.mobile{\n    background-color: var(--semiDark);\n    box-shadow:\n        inset 0px 6px 5px var(--light),\n        inset 0px -5px 5px var(--primary),\n        -5px 8px 8px var(--dark),\n        5px 8px 8px var(--palleteGray);\n    border-top-left-radius: 50% 20% ;\n    border-bottom-left-radius: 50% 20% ;\n    border-top-right-radius: 50% 20% ;\n    border-bottom-right-radius: 50% 20%;\n}\n.slider0{\n    transition-property: height, width; \n    transition-duration: 1s; \n    transition-delay: 500ms;\n}\n\n.card-header{\n    font-family: 'Rockwell', 'Rokkitt', 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;\n}\n\n.header-bg{\n    background-position-y: 43% !important;\n}\n\n.iconLink{\n    color: var(--light)\n}\n.iconLink:hover{\n    color: var(--spark); \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
